import React from 'react';
import { Helmet } from 'react-helmet';
import site from '../../seo/site.json';

// Per-page <head> tags for search engines, AI crawlers and link previews.
// Renders nothing on the page. Titles and descriptions live in
// src/seo/site.json (the SEO source of truth) — pages just pass their path.
// public/index.html carries default tags marked data-react-helmet="true" so
// Helmet replaces them rather than duplicating them.
export const SITE_URL = site.siteUrl;

function Seo({ path = '/', title, description, socialDescription, children }) {
  const route = site.publicRoutes.find((r) => r.path === path) || {};
  const pageTitle = title || route.title || site.defaults.title;
  const pageDescription = description || route.description || site.defaults.description;
  const pageSocial = socialDescription || route.socialDescription || pageDescription;
  const url = `${SITE_URL}${path}`;
  const image = `${SITE_URL}/og-image.jpg`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={site.siteName} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageSocial} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageSocial} />
      <meta name="twitter:image" content={image} />
      {children}
    </Helmet>
  );
}

export default Seo;
